import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useToast } from "@/hooks/use-toast";
import { Button } from "@/components/ui/button";
import ProprietarioForm from "@/components/proprietarios/ProprietarioForm";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";

const EditOwnerPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { toast } = useToast();
  const location = useLocation();
  const owner = location.state?.owner;

  const handleSubmit = async (data: any) => {
    try {
      // The actual saving is now handled in the ProprietarioForm component
      await data;
      
      toast({
        title: "Sucesso!",
        description: "Proprietário atualizado com sucesso.",
      });
      
      navigate("/proprietarios");
    } catch (error) {
      console.error("Erro ao atualizar proprietário:", error);
      toast({
        variant: "destructive",
        title: "Erro!",
        description: "Ocorreu um erro ao atualizar o proprietário.",
      });
    }
  };

  if (!owner) {
    return (
      <div className="p-8 text-center">
        <h2 className="text-xl font-semibold text-red-600">Proprietário não encontrado</h2>
        <Button onClick={() => navigate("/proprietarios")} className="mt-4">
          Voltar para lista
        </Button>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl animate-fade-in">
      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg shadow-sm p-8 mb-8">
        <h1 className="text-3xl font-heading font-bold bg-gradient-to-r from-primary to-blue-600 bg-clip-text text-transparent">
          Editar Proprietário
        </h1>
        <p className="mt-2 text-gray-600">
          Última atualização: {format(owner.lastUpdateDate, "dd 'de' MMMM 'de' yyyy", { locale: ptBR })}
        </p>
      </div>

      <div className="bg-white rounded-lg shadow-sm p-8">
        <ProprietarioForm
          onSubmit={handleSubmit}
          isEditing={true}
          owner={owner}
        />
      </div>
    </div>
  );
};

export default EditOwnerPage;